import "./AzmaHealthBudget.css";

const packages = [
  {
    name: "Package One",
    price: "1.5 lacs",
    timeline: "20 days",
    sections: [
      {
        title: "Service Modules",
        items: ["Doctor Appointment", "Pathology Test"],
      },
      {
        title: "System Modules / Admin / Support",
        items: [
          "User Management",
          "Booking System",
          "Payment System",
          "Admin Panel",
        ],
      },
      {
        title: "Infrastructure & Extras",
        items: ["Server & Hosting", "UI/UX Design"],
      },
    ],
  },
  {
    name: "Package Two",
    price: "1 lac",
    timeline: "20 days",
    sections: [
      {
        title: "Service Modules",
        items: [
          "Blood Bank",
          "Ambulance Booking",
          "Nurse Booking",
          "Therapy Booking",
          "Pregnancy Care",
        ],
      },
      {
        title: "System Modules / Admin / Support",
        items: ["Advanced Blood Bank & Community"],
      },
      {
        title: "Infrastructure & Extras",
        items: ["UI/UX Design modification", "QA & Testing", "Miscellaneous"],
      },
    ],
  },
  {
    name: "Package Three",
    price: "1 lac",
    timeline: "20 days",
    sections: [
      {
        title: "Service Modules",
        items: ["Pharmacy", "Telemedicine", "Hijama Module"],
      },
      {
        title: "System Modules / Admin / Support",
        items: [
          "User Management modification",
          "Partner System",
          "Admin Panel modification",
        ],
      },
      {
        title: "Infrastructure & Extras",
        items: [
          "final UI/UX Design",
          "final QA & Testing",
          "final Miscellaneous",
        ],
      },
    ],
  },
];

export const AzmaHealthBudget = () => {
  return (
    <section className="azma-budget" id="azma-health-budget">
      <div className="azma-budget__header">
        <p className="azma-budget__eyebrow">Azma Health Solution</p>
        <h1 className="azma-budget__title">Budget estimation</h1>
        <p className="azma-budget__subtitle">
          Module-by-module scope estimate for planning and stakeholder alignment.
        </p>
      </div>

      <div className="azma-budget__packages">
        {packages.map((pack) => (
          <article className="azma-budget__card" key={pack.name}>
            <div className="azma-budget__card-top">
              <div>
                <p className="azma-budget__card-label">{pack.name}</p>
                <h2 className="azma-budget__card-title">Azma Health Package</h2>
              </div>
              <div className="azma-budget__price">
                <span className="azma-budget__price-value">{pack.price}</span>
                <span className="azma-budget__price-text">BDT</span>
              </div>
            </div>

            <div className="azma-budget__card-body">
              <div className="azma-budget__timeline">
                <span className="azma-budget__timeline-label">Timeline</span>
                <span className="azma-budget__timeline-value">{pack.timeline}</span>
              </div>
              {pack.sections.map((section, sectionIndex) => (
                <div className="azma-budget__group" key={section.title}>
                  <div className="azma-budget__group-title">
                    <span className="azma-budget__group-index">{sectionIndex + 1}</span>
                    <h3>{section.title}</h3>
                  </div>
                  <ul className="azma-budget__list">
                    {section.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </article>
        ))}
      </div>

      <div className="azma-budget__summary">
        <div className="azma-budget__summary-card">
          <p className="azma-budget__summary-title">Combined Packages Summary</p>
          <div className="azma-budget__summary-items">
            <div>
              <span className="azma-budget__summary-label">Total price</span>
              <span className="azma-budget__summary-value">3.5 lacs</span>
            </div>
            <div>
              <span className="azma-budget__summary-label">Estimated time</span>
              <span className="azma-budget__summary-value">2 months</span>
            </div>
          </div>
        </div>
      </div>

      <div className="azma-budget__stack">
        <div className="azma-budget__stack-card">
          <p className="azma-budget__stack-title">Stack Details</p>
          <ul className="azma-budget__stack-list">
            <li>Android and iOS app will be made by Flutter.</li>
            <li>Website and admin panel frontend will be built with React JS.</li>
            <li>Backend and API will be developed with Laravel.</li>
          </ul>
        </div>
      </div>

      <div className="azma-budget__footer">
        <p>
          Note: Estimates shown in Bangladeshi Taka (BDT). Final pricing may vary
          based on feature depth, third-party integrations, and timeline.
        </p>
      </div>
    </section>
  );
};
